var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSieteHorneros(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.3932H24.5353M3.12208 17.3932V7.57897H5.80651M22.7506 17.3932V7.57897H19.8946M12.9363 1.03613L19.4792 4.30755V17.3932H6.3935V4.30755L12.9363 1.03613ZM11.3006 17.3932V12.4861H14.572V17.3932H11.3006ZM12.9363 9.21467C12.033 9.21467 11.3006 8.48233 11.3006 7.57897C11.3006 6.6756 12.033 5.94326 12.9363 5.94326C13.8397 5.94326 14.572 6.6756 14.572 7.57897C14.572 8.48233 13.8397 9.21467 12.9363 9.21467Z",
    stroke: "#CDA47E",
    strokeWidth: 1.63571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSieteHorneros);
export default __webpack_public_path__ + "static/media/iconSieteHorneros.6c1eb42cce7a2e93a6f5ba439cb4c5e3.svg";
export { ForwardRef as ReactComponent };